// French UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const fr: Record<string, string> = {
  "+ Add": "+ Ajouter",
  "+ Task": "+ Tâche",
  "+ sub": "+ sous",
  "1 person notified": "1 personne notifiée",
  "1 private project hidden": "1 projet privé masqué",
  "1 private project is hidden from these totals.": "1 projet privé est exclu de ces totaux.",
  "1 project": "1 projet",
  "1 year": "1 an",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. Scannez le code avec votre application d’authentification, ou saisissez cette clé manuellement :",
  "13 weeks": "13 semaines",
  "2. Enter the 6-digit code the app shows to confirm.": "2. Saisissez le code à 6 chiffres affiché par l’application pour confirmer.",
  "26 weeks": "26 semaines",
  "30 days": "30 jours",
  "4 weeks": "4 semaines",
  "8 weeks": "8 semaines",
  "90 days": "90 jours",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "Un indicateur est un interrupteur nommé que vous contrôlez ici sans déploiement. Chaque navigateur connecté reçoit les indicateurs actuels et les fonctionnalités peuvent les consulter pour afficher ou masquer quelque chose.",
  "A person is": "Une personne est",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "Un portefeuille regroupe des projets liés sous une même initiative (un client, un programme, un service) avec un tableau, une liste et un Gantt partagés.",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "Un portefeuille regroupe des projets liés sous une même initiative (un client, un programme, un service).",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "Un projet privé n’apparaît que dans votre propre liste de projets — personne d’autre ne peut le voir, quel que soit son rôle",
  "A simple sub-task with its own key; it appears here, not on the board": "Une sous-tâche simple avec sa propre clé ; elle apparaît ici, pas sur le tableau",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "Un jeton agit au nom de cette personne via l’API : projets, portefeuilles, tâches, plannings et son temps, jamais les taux, la paie ni l’administration. Tout ce qu’il fait est audité en son nom, avec le nom du jeton, et votre nom est enregistré comme émetteur.",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "Un jeton permet à Claude Code (ou à un script) d’agir en votre nom via l’API : projets, portefeuilles, tâches, plannings, liens, jalons et votre temps. Il n’atteint jamais les taux, budgets, la paie, les approbations, l’administration ni les paramètres du compte, quel que soit votre rôle.",
  "API tokens": "Jetons d’API",
  "Account": "Compte",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "Les comptes sont sur invitation uniquement. Si vous avez un lien d’invitation, ouvrez-le pour configurer votre compte.",
  "Active only": "Actives uniquement",
  "Add": "Ajouter",
  "Add a comment": "Ajouter un commentaire",
  "Add a milestone on this day": "Ajouter un jalon ce jour-là",
  "Add a person": "Ajouter une personne",
  "Add a person…": "Ajouter une personne…",
  "Add a status column (columns are the project's statuses)": "Ajouter une colonne de statut (les colonnes sont les statuts du projet)",
  "Add a subtask under this task": "Ajouter une sous-tâche sous cette tâche",
  "Add a task due on this day": "Ajouter une tâche échéant ce jour-là",
  "Add a task in this column": "Ajouter une tâche dans cette colonne",
  "Add a top-level task": "Ajouter une tâche de premier niveau",
  "Add checklist item": "Ajouter un élément de checklist",
  "Add column": "Ajouter une colonne",
  "Add entry": "Ajouter une saisie",
  "Add holiday": "Ajouter un jour férié",
  "Add project…": "Ajouter un projet…",
  "Add rate": "Ajouter un tarif",
  "Add subtask": "Ajouter une sous-tâche",
  "Add task": "Ajouter une tâche",
  "Add the column at the end; drag its header to reorder": "Ajoute la colonne à la fin ; faites glisser son en-tête pour réordonner",
  "Add the item": "Ajouter l’élément",
  "Added": "Ajouté",
  "Address / CIDR": "Adresse / CIDR",
  "Addresses on file (restriction currently off):": "Adresses enregistrées (restriction actuellement désactivée) :",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "Ajoute une deuxième étape à la connexion par mot de passe : un code à 6 chiffres d’une application comme Google Authenticator, 1Password ou Authy.",
  "Admin console": "Console d’administration",
  "After": "Après",
  "Alert at %": "Alerte à %",
  "All portfolios you can see; create one there": "Tous les portefeuilles que vous pouvez voir ; créez-en un là",
  "All projects": "Tous les projets",
  "All states": "Tous les états",
  "Amount": "Montant",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "Un compte pour une intégration : il reste hors de la paie, des feuilles de temps et des rapports planifiés",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "Une invitation leur laisse choisir leur mot de passe. Créer un compte ici n’envoie aucun e-mail : il existe immédiatement et c’est vous qui décidez s’il a un mot de passe.",
  "Analytics": "Analytique",
  "Any action": "Toute action",
  "Any milestone": "Tout jalon",
  "Any priority": "Toute priorité",
  "Any project": "Tout projet",
  "Any status": "Tout statut",
  "Anyone": "N’importe qui",
  "Approvals": "Approbations",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "Approuver bien que non soumis — vous serez averti si la semaine est vide ou légère, et la personne est notifiée",
  "Approve without submission?": "Approuver sans soumission ?",
  "Approve — locks the week; any later work must be a correction entry": "Approuver — verrouille la semaine ; tout travail ultérieur doit être une saisie de correction",
  "Approve — reduces their available capacity for those days": "Approuver — réduit leur capacité disponible pour ces jours",
  "Approved": "Approuvé",
  "Archive": "Archiver",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "Archiver ce portefeuille ? Ses projets restent inchangés ; le portefeuille disparaît des listes par défaut.",
  "Assign to…": "Assigner à…",
  "Assignee": "Responsable",
  "At a glance": "En un coup d’œil",
  "At least 12 characters. A password found in a public breach is refused.": "Au moins 12 caractères. Un mot de passe présent dans une fuite publique est refusé.",
  "At least 12 characters. A short sentence works well.": "Au moins 12 caractères. Une courte phrase convient bien.",
  "Attach files": "Joindre des fichiers",
  "Attach files to the comment; you can also paste or drop them into it": "Joindre des fichiers au commentaire ; vous pouvez aussi les coller ou les déposer dedans",
  "Attach files to this task; you can also drop them here": "Joindre des fichiers à cette tâche ; vous pouvez aussi les déposer ici",
  "Attachments": "Pièces jointes",
  "Auto-schedule": "Planification automatique",
  "Avatar URL": "URL de l’avatar",
  "Awaiting approval": "En attente d’approbation",
  "Awaiting your approval": "En attente de votre approbation",
  "Back": "Retour",
  "Back to portfolios": "Retour aux portefeuilles",
  "Back to projects": "Retour aux projets",
  "Baseline": "Référence",
  "Before": "Avant",
  "Bill rates": "Tarifs de facturation",
  "Billable + non": "Facturable + non",
  "Billable only": "Facturable uniquement",
  "Billable value": "Valeur facturable",
  "Board": "Tableau",
  "Breadcrumb": "Fil d’Ariane",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "Chargez en masse des personnes, des projets et un backlog de tâches initial depuis des fichiers CSV.",
  "Calendar": "Calendrier",
  "Calendar settings": "Paramètres du calendrier",
  "Cancel": "Annuler",
  "Cancel this pending invite": "Annuler cette invitation en attente",
  "Cancel this request (or approved leave that hasn't started)": "Annuler cette demande (ou un congé approuvé qui n’a pas commencé)",
  "Capacity": "Capacité",
  "Category": "Catégorie",
  "Change any field on this person's record, including their email": "Modifier n’importe quel champ de la fiche de cette personne, y compris son e-mail",
  "Change password": "Changer le mot de passe",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "Changer l’e-mail de {name} en {email} ? C’est à cette adresse qu’arrivent les réinitialisations de mot de passe, et la personne est prévenue du changement.",
  "Changes save as you edit; this confirms and closes the editor": "Les modifications s’enregistrent au fil de la saisie ; ceci confirme et ferme l’éditeur",
  "Checking invite…": "Vérification de l’invitation…",
  "Checking…": "Vérification…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "Choisissez le fuseau horaire avec soin — il ne peut pas être modifié ensuite.",
  "Clear": "Effacer",
  "Click": "Cliquez",
  "Click the": "Cliquez sur",
  "Close": "Fermer",
  "Collapse": "Replier",
  "Collapse this card": "Replier cette carte",
  "Collapse this section (remembered for you)": "Replier cette section (mémorisé pour vous)",
  "Colour": "Couleur",
  "Delete {name}?": "Supprimer {name} ?",
  "Download": "Télécharger",
  "No files yet. Drop files here or use Attach files.": "Aucun fichier pour l’instant. Déposez des fichiers ici ou utilisez Joindre des fichiers.",
  "No files.": "Aucun fichier.",
  "Owner": "Responsable",
  "Colour the task bars by owner (assignee). Remembered.": "Colorer les barres de tâches par responsable (personne assignée). Mémorisé.",
  "Colour for this calendar's events": "Couleur des événements de ce calendrier",
  "Column (status) name shown on the board": "Nom de la colonne (statut) affiché sur le tableau",
  "Column name": "Nom de la colonne",
  "Command": "Commande",
  "Command palette": "Palette de commandes",
  "Comment": "Commentaire",
  "Comment deleted": "Commentaire supprimé",
  "Comment deleted by {name}": "Commentaire supprimé par {name}",
  "Comments": "Commentaires",
  "Commit": "Valider",
  "Company holidays": "Jours fériés de l’entreprise",
  "Completed": "Terminé",
  "Confirm new password": "Confirmer le nouveau mot de passe",
  "Confirm password": "Confirmer le mot de passe",
  "Connect Google Calendar": "Connecter Google Agenda",
  "Connecting failed. Try again.": "La connexion a échoué. Réessayez.",
  "Continue with Google": "Continuer avec Google",
  "Copied": "Copié",
  "Copy all": "Tout copier",
  "Copy link": "Copier le lien",
  "Copy password": "Copier le mot de passe",
  "Copy the claude mcp add command": "Copier la commande claude mcp add",
  "Copy the export line": "Copier la ligne export",
  "Copy the password so you can pass it on": "Copier le mot de passe pour le transmettre",
  "Copy the token": "Copier le jeton",
  "Correct…": "Corriger…",
  "Cost rate": "Taux de coût",
  "Cost rates": "Taux de coût",
  "Could not create portfolio": "Impossible de créer le portefeuille",
  "Could not load the overview.": "Impossible de charger la vue d’ensemble.",
  "Create a one-time invite link (7 days) and email it if mail is configured": "Créer un lien d’invitation à usage unique (7 jours) et l’envoyer par e-mail si la messagerie est configurée",
  "Create a project — you'll choose its permanent timezone-of-truth": "Créer un projet — vous choisirez son fuseau horaire de référence permanent",
  "Create a task scheduled today for one week; drag its bar to adjust": "Créer une tâche planifiée aujourd’hui pour une semaine ; faites glisser sa barre pour ajuster",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "Créer une tâche de premier niveau dans ce projet ; ouvrez-la ensuite pour définir dates, responsable, estimation",
  "Create account": "Créer le compte",
  "Create feed link": "Créer le lien du flux",
  "Create invite": "Créer une invitation",
  "Create one below, then file projects under it from a project's": "Créez-en un ci-dessous, puis classez-y des projets depuis les",
  "Create one from the Portfolios page, then file projects under it from a project's": "Créez-en un depuis la page Portefeuilles, puis rattachez-y des projets depuis la page de chaque projet, dans",
  "Create project": "Créer le projet",
  "Create the account now — nobody is emailed": "Créer le compte maintenant — aucun e-mail n’est envoyé",
  "Create the task": "Créer la tâche",
  "Create the task in this column": "Créer la tâche dans cette colonne",
  "Create token": "Créer un jeton",
  "Create your personal feed link": "Créer votre lien de flux personnel",
  "Created": "Créé",
  "Cumulative flow": "Flux cumulé",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "Flux cumulé, temps de cycle, burndown, vélocité, prévision",
  "Currency": "Devise",
  "Current password": "Mot de passe actuel",
  "Cycle (d)": "Cycle (j)",
  "Dashboard, projects, members, settings": "Tableau de bord, projets, membres, paramètres",
  "Dashboard, tasks, members, milestones, settings": "Tableau de bord, tâches, membres, jalons, paramètres",
  "Dates in": "Dates en",
  "Day": "Jour",
  "Deactivate your account (history is kept); you will be asked to confirm": "Désactiver votre compte (l’historique est conservé) ; une confirmation vous sera demandée",
  "Decides whether this account can sign in the moment you create it": "Détermine si ce compte peut se connecter dès sa création",
  "Decline with a reason; the person is notified": "Refuser avec un motif ; la personne est notifiée",
  "Delete": "Supprimer",
  "Delete column": "Supprimer la colonne",
  "Delete milestone": "Supprimer le jalon",
  "Delete task": "Supprimer la tâche",
  "Delete this column (only when empty)": "Supprimer cette colonne (seulement si vide)",
  "Delete this comment? Its replies stay.": "Supprimer ce commentaire ? Ses réponses sont conservées.",
  "Delete this milestone": "Supprimer ce jalon",
  "Delete this task": "Supprimer cette tâche",
  "Delete this task (and its subtasks); logged time is kept": "Supprimer cette tâche (et ses sous-tâches) ; le temps saisi est conservé",
  "Remove this file": "Retirer ce fichier",
  "Resize the task list": "Redimensionner la liste des tâches",
  "Drag to resize the task list; double-click to reset": "Faites glisser pour redimensionner la liste des tâches ; double-cliquez pour réinitialiser",
  "Delete this task and its subtasks; logged time is kept": "Supprimer cette tâche et ses sous-tâches ; le temps saisi est conservé",
  "Directory": "Annuaire",
  "Discard": "Abandonner",
  "Discuss this milestone": "Discuter de ce jalon",
  "Discussion": "Discussion",
  "Dismiss": "Fermer",
  "Display only — never changes which week an entry belongs to.": "Affichage uniquement — ne change jamais la semaine à laquelle une saisie appartient.",
  "Does not match.": "Ne correspond pas.",
  "Done": "Terminé",
  "Download CSV": "Télécharger le CSV",
  "Download a JSON file with everything stored about you": "Télécharger un fichier JSON avec tout ce qui est stocké à votre sujet",
  "Download as a PDF table": "Télécharger sous forme de tableau PDF",
  "Download as an Excel workbook": "Télécharger sous forme de classeur Excel",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "Téléchargez tout ce qui est stocké à votre sujet — profil, appartenances, saisies de temps, tâches assignées, congés, approbations, notifications — au format JSON.",
  "Download my data": "Télécharger mes données",
  "Download partial CSV": "Télécharger le CSV partiel",
  "Download these rows as CSV": "Télécharger ces lignes en CSV",
  "Drag cards, or focus a card and press": "Faites glisser les cartes, ou sélectionnez une carte et appuyez sur",
  "Drag to change priority; Space + arrows works from the keyboard": "Faites glisser pour changer la priorité ; Espace + flèches fonctionne au clavier",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "Faites glisser pour déplacer entre colonnes ou réordonner ; Espace + flèches fonctionne au clavier",
  "Drop idle time — save up to the idle moment, then restart": "Ignorer le temps d’inactivité — enregistrer jusqu’au moment d’inactivité, puis redémarrer",
  "Due": "Échéance",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "Chaque statut correspond à une catégorie globale (à faire / en cours / terminé / archivé) pour que les rapports fonctionnent entre projets. Gardez-en au moins un par catégorie. Le travail archivé est exclu de tous les décomptes et masqué sauf demande.",
  "Archived": "Archivé",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "Afficher aussi les tâches dans un statut archivé. Le choix est mémorisé et partagé par les vues de tâches et le tableau.",
  "Upload failed": "Échec de l’envoi",
  "Uploading 1 file…": "Envoi d’1 fichier…",
  "Uploading {n} files…": "Envoi de {n} fichiers…",
  "Waterfall": "Cascade",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "Disposer les tâches liées de gauche à droite : toute tâche qui chevauche ce que ses liens permettent est décalée plus tard (en gardant sa durée), puis les lignes sont triées par début, les tâches liées dans l’ordre des liens. Les tâches terminées et archivées ne bougent pas. Enregistré ; appuyez à nouveau après des changements.",
  "Waterfall:": "Cascade :",
  "in a comment": "dans un commentaire",
  "rescheduled": "replanifiées",
  "reordered": "réordonnées",
  "Already a waterfall: nothing to change": "Déjà en cascade : rien à changer",
  "Could not reschedule the tasks": "Impossible de replanifier les tâches",
  "Auto-schedule:": "Planification automatique :",
  "Already scheduled: nothing to change": "Déjà planifié : rien à changer",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "La planification automatique replanifie chaque tâche ouverte : d’abord le travail en cours, puis les tâches liées dès que leurs liens le permettent et les autres à partir d’aujourd’hui, pour que personne n’ait deux tâches à la fois. Continuer ?",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "Planifier au plus tôt les tâches ouvertes : les tâches liées dès que leurs liens le permettent, les non liées passées ou sans dates à partir d’aujourd’hui (les sans dates prennent leur estimation à 8 h par jour, ou 5 jours), les futures non liées gardent leur début. Les tâches de chaque personne sont mises en file, d’abord celles en cours puis par priorité, pour ne jamais se chevaucher, en comptant ses autres projets. Les tâches terminées et archivées ne bougent pas. Enregistré.",
  "working days": "jours ouvrés",
  "estimated": "estimées",
  "Edit": "Modifier",
  "Edit person": "Modifier la personne",
  "Edit your comment; the previous text is kept as history": "Modifiez votre commentaire ; le texte précédent est conservé dans l’historique",
  "Elapsed": "Écoulé",
  "Email": "E-mail",
  "End this session and return to the sign-in page (other devices stay signed in)": "Terminer cette session et revenir à la page de connexion (les autres appareils restent connectés)",
  "Ends": "Fin",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "Saisissez le code à 6 chiffres de votre application d’authentification, ou l’un de vos codes de récupération.",
  "Epic": "Épopée",
  "Estimate (h)": "Estimation (h)",
  "Every project-week approved": "Toutes les semaines-projet approuvées",
  "Everyone": "Tout le monde",
  "Everyone (admin)": "Tout le monde (admin)",
  "Everyone in the range is approved — download the payroll CSV": "Tout le monde dans la période est approuvé — téléchargez le CSV de paie",
  "Everything on this person's record. Changes are audit-logged against your name.": "Tout ce que contient la fiche de cette personne. Les modifications sont journalisées à votre nom.",
  "Examples:": "Exemples :",
  "Excludes people who still have unapproved weeks; they are named in the file header": "Exclut les personnes ayant encore des semaines non approuvées ; elles sont nommées dans l’en-tête du fichier",
  "Expand": "Déplier",
  "Expand this card to see details": "Déplier cette carte pour voir les détails",
  "Expand this section (remembered for you)": "Déplier cette section (mémorisé pour vous)",
  "Expires": "Expire",
  "External calendars (in)": "Calendriers externes (entrant)",
  "Feature flags": "Indicateurs de fonctionnalités",
  "Field": "Champ",
  "Filter the list by project code or name": "Filtrer la liste par code ou nom de projet",
  "Final step: deactivate the account now": "Dernière étape : désactiver le compte maintenant",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "Pour une intégration comme Claude Code, pas pour un collègue : il reste hors de la paie, des feuilles de temps et des rapports planifiés.",
  "From": "De",
  "From your calendar today": "De votre agenda d’aujourd’hui",
  "Global category this column maps to, so cross-project reports keep working": "Catégorie globale à laquelle cette colonne correspond, pour que les rapports inter-projets continuent de fonctionner",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "Google n’a pas accordé l’accès hors ligne — retirez ADKOM PM des accès tiers de votre compte Google, puis reconnectez-vous.",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "Accorder un accès en lecture seule ; les réunions du jour deviennent des suggestions de saisie de temps en un clic",
  "Group by": "Grouper par",
  "Group the board into rows by assignee, epic or priority": "Grouper le tableau en lignes par responsable, épopée ou priorité",
  "Has unapproved weeks": "A des semaines non approuvées",
  "Hidden projects are a personal view preference; nothing about the project changes": "Les projets masqués sont une préférence d’affichage personnelle ; rien ne change pour le projet",
  "Hide subtasks": "Masquer les sous-tâches",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "Afficher uniquement les tâches en cours, en masquant le backlog et les terminées. Le choix est mémorisé et partagé par les vues de tâches.",
  "Hide tasks that are done. Remembered, and shared by the task views.": "Masquer les tâches terminées. Le choix est mémorisé et partagé par les vues de tâches.",
  "Show backlog": "Afficher le backlog",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "Avec « Actives uniquement » activé, afficher aussi les tâches encore dans le backlog. Le choix est mémorisé.",
  "Hide this milestone's discussion": "Masquer la discussion de ce jalon",
  "Hide this project from your lists (just for you; the project is unchanged)": "Masquer ce projet de vos listes (juste pour vous ; le projet est inchangé)",
  "Hide this project's tasks": "Masquer les tâches de ce projet",
  "Hours": "Heures",
  "Hours (30d)": "Heures (30 j)",
  "Hours for other members are visible to project administrators and managers.": "Les heures des autres membres sont visibles par les administrateurs de projet et les managers.",
  "Hours per week": "Heures par semaine",
  "Hours/wk": "Heures/sem",
  "How much of their time the schedule may plan for.": "La part de son temps que le planning peut prévoir.",
  "IP allowlist set by an administrator": "Liste d’adresses IP autorisées définie par un administrateur",
  "Identifies this project's tasks on portfolio boards and Gantts": "Identifie les tâches de ce projet sur les tableaux et Gantt du portefeuille",
  "Import": "Importer",
  "Import in order: people → projects → tasks.": "Importez dans l’ordre : personnes → projets → tâches.",
  "In progress": "En cours",
  "Include accounts used by integrations, which are hidden by default": "Inclure les comptes utilisés par les intégrations, masqués par défaut",
  "Invite": "Inviter",
  "Invite colleagues and manage roles.": "Invitez des collègues et gérez les rôles.",
  "Invite for": "Invitation pour",
  "Issue a token for this person and show it once": "Émettre un jeton pour cette personne et l’afficher une seule fois",
  "Issue or revoke tokens that act as this person through the API": "Émettre ou révoquer des jetons qui agissent au nom de cette personne via l’API",
  "Issues assigned to this GitHub user become tasks assigned to them.": "Les issues attribuées à cet utilisateur GitHub deviennent des tâches qui lui sont attribuées.",
  "Job title": "Intitulé du poste",
  "Jump to the current week": "Aller à la semaine en cours",
  "Jump to the top of the page": "Aller en haut de la page",
  "Jump to top": "Aller en haut",
  "Kanban board across every project in the portfolio": "Tableau Kanban couvrant tous les projets du portefeuille",
  "Kanban board: drag cards between status columns": "Tableau Kanban : faites glisser les cartes entre les colonnes de statut",
  "Keep": "Conserver",
  "Keep the account": "Conserver le compte",
  "Keep — count the idle time as work": "Conserver — compter le temps d’inactivité comme du travail",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "Garde ce compte hors de la paie, des feuilles de temps et des rapports planifiés.",
  "Key": "Clé",
  "Kind": "Type",
  "Label": "Libellé",
  "Language": "Langue",
  "Last": "Dernier",
  "Last active": "Dernière activité",
  "Last run": "Dernière exécution",
  "Last sign-in": "Dernière connexion",
  "Last used": "Dernière utilisation",
  "Lead (d)": "Délai (j)",
  "Leave": "Congés",
  "Leave it empty to follow the organisation's working week.": "Laissez vide pour suivre la semaine de travail de l’organisation.",
  "Line": "Ligne",
  "List": "Liste",
  "Loading…": "Chargement…",
  "Log time →": "Saisir du temps →",
  "Logged": "Saisi",
  "Managed by": "Géré par",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · tapez @ pour mentionner quelqu’un · Ctrl-Entrée publie",
  "Median cycle time": "Temps de cycle médian",
  "Median lead time": "Délai médian",
  "Member": "Membre",
  "Members": "Membres",
  "Mention someone": "Mentionner quelqu’un",
  "Milestone": "Jalon",
  "Milestones": "Jalons",
  "Milestone…": "Jalon…",
  "Mine open": "Mes ouvertes",
  "Month": "Mois",
  "Month view of due dates, milestones and external calendars": "Vue mensuelle des échéances, jalons et calendriers externes",
  "More actions for this row": "Plus d’actions pour cette ligne",
  "Move this status up one place": "Monter ce statut d’une place",
  "Move up": "Monter",
  "Moving a project out of a portfolio is refused while it has cross-project links": "Impossible de retirer un projet d’un portefeuille tant qu’il a des liens inter-projets",
  "My private projects": "Mes projets privés",
  "My reports": "Mes rapports",
  "My requests": "Mes demandes",
  "My tasks": "Mes tâches",
  "Name": "Nom",
  "New milestone": "Nouveau jalon",
  "New password": "Nouveau mot de passe",
  "New portfolio": "Nouveau portefeuille",
  "New portfolio name": "Nom du nouveau portefeuille",
  "New project": "Nouveau projet",
  "New status": "Nouveau statut",
  "New subtask": "Nouvelle sous-tâche",
  "New task": "Nouvelle tâche",
  "New task in": "Nouvelle tâche dans",
  "New task title": "Titre de la nouvelle tâche",
  "New timer": "Nouveau chrono",
  "Next milestone": "Prochain jalon",
  "Next month": "Mois suivant",
  "Next run": "Prochaine exécution",
  "Next week": "Semaine suivante",
  "No comments yet.": "Pas encore de commentaires.",
  "No completed work in the window yet.": "Aucun travail terminé dans la fenêtre pour l’instant.",
  "No cost rate yet.": "Pas encore de taux de coût.",
  "No data.": "Aucune donnée.",
  "No earlier versions.": "Aucune version antérieure.",
  "No feed link yet.": "Pas encore de lien de flux.",
  "No hours budget set.": "Aucun budget d’heures défini.",
  "No members yet.": "Aucun membre pour l’instant.",
  "No milestones yet.": "Pas encore de jalons.",
  "No money budget set.": "Aucun budget monétaire défini.",
  "No open milestones with a due date.": "Aucun jalon ouvert avec une échéance.",
  "No portfolios yet.": "Aucun portefeuille pour l’instant.",
  "No projects filed here yet.": "Aucun projet rattaché ici pour l’instant.",
  "No projects in this portfolio yet.": "Aucun projet dans ce portefeuille pour l’instant.",
  "No projects match.": "Aucun projet ne correspond.",
  "No projects yet.": "Pas encore de projets.",
  "No projects.": "Aucun projet.",
  "No tasks yet.": "Pas encore de tâches.",
  "No tasks.": "Aucune tâche.",
  "No time in this range.": "Aucun temps sur cette période.",
  "No time in this window.": "Aucun temps dans cette fenêtre.",
  "No time matches.": "Aucun temps ne correspond.",
  "No tokens yet.": "Aucun jeton pour l’instant.",
  "Non-billable only": "Non facturable uniquement",
  "None": "Aucun",
  "None yet.": "Rien pour l’instant.",
  "Not available — approvals are for project administrators.": "Non disponible — les approbations sont réservées aux administrateurs de projet.",
  "Not configured on this server.": "Non configuré sur ce serveur.",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "Pas encore assez d’historique pour une tendance — le graphique hebdomadaire apparaît après deux semaines de saisies.",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "Pas encore assez d’historique pour les tendances et prévisions — elles se stabilisent après quelques semaines de mouvement des tâches. Ce qui est ici est exact, juste court.",
  "Not enough history yet — the chart appears once two project weeks have entries.": "Pas encore assez d’historique — le graphique apparaît dès que deux semaines-projet ont des saisies.",
  "Not submitted": "Non soumis",
  "Note (optional)": "Note (facultatif)",
  "Note saved onto the entry": "Note enregistrée sur la saisie",
  "Note saved onto the time entry when you stop": "Note enregistrée sur la saisie de temps à l’arrêt",
  "Nothing assigned to you.": "Rien ne vous est assigné.",
  "Nothing completed yet.": "Rien de terminé pour l’instant.",
  "Nothing here.": "Rien ici.",
  "Nothing logged yet.": "Rien de saisi pour l’instant.",
  "Nothing recorded yet.": "Rien d’enregistré pour l’instant.",
  "Nothing to preview yet.": "Rien à prévisualiser pour l’instant.",
  "Nothing yet.": "Rien pour l’instant.",
  "Now click the task that must wait for": "Cliquez maintenant sur la tâche qui doit attendre",
  "On enter": "À l’entrée",
  "One submission per project per week, in each project's own timezone.": "Une soumission par projet et par semaine, dans le fuseau horaire de chaque projet.",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "Seuls les enregistrements éphémères sont purgés. L’historique métier — saisies de temps, approbations, tâches, journal d’audit, transitions de statut — n’est jamais touché.",
  "Only you can see these. Drag to prioritize.": "Vous seul pouvez les voir. Faites glisser pour prioriser.",
  "Open People": "Ouvrir Personnes",
  "Open People: directory, roles, invites": "Ouvrir Personnes : annuaire, rôles, invitations",
  "Open Projects": "Ouvrir Projets",
  "Open Reports to slice logged time": "Ouvrir Rapports pour analyser le temps saisi",
  "Open portfolio →": "Ouvrir le portefeuille →",
  "Open tasks": "Tâches ouvertes",
  "Open the Gantt chart": "Ouvrir le diagramme de Gantt",
  "Open the Kanban board": "Ouvrir le tableau Kanban",
  "Open the Time page: edit timers, notes, tasks": "Ouvrir la page Temps : modifier chronos, notes, tâches",
  "Open the portfolio": "Ouvrir le portefeuille",
  "Open the portfolio: shared board, list and Gantt across its projects": "Ouvrir le portefeuille : tableau, liste et Gantt partagés entre ses projets",
  "Open the project": "Ouvrir le projet",
  "Open the task": "Ouvrir la tâche",
  "Outstanding": "En attente",
  "Overdue": "En retard",
  "Overview": "Vue d’ensemble",
  "Password": "Mot de passe",
  "Paste CSV here…": "Collez le CSV ici…",
  "Pause this timer; time is kept": "Mettre ce chrono en pause ; le temps est conservé",
  "Pause; time is kept": "Pause ; le temps est conservé",
  "Payroll export": "Export de paie",
  "Pending": "En attente",
  "People": "Personnes",
  "Per-project feeds:": "Flux par projet :",
  "Permanent. Create a new project to use a different zone.": "Permanent. Créez un nouveau projet pour utiliser un autre fuseau.",
  "Person": "Personne",
  "Person…": "Personne…",
  "Pick the range by": "Choisissez la période par",
  "Portfolio": "Portefeuille",
  "Portfolio manager": "Manager du portefeuille",
  "Portfolio not found, or you do not have access.": "Portefeuille introuvable, ou vous n’y avez pas accès.",
  "Portfolio role": "Rôle dans le portefeuille",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "Les rôles de portefeuille donnent accès aux vues fusionnées ; la modification des tâches suit toujours l’appartenance à chaque projet.",
  "Portfolios": "Portefeuilles",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "Les portefeuilles n’affectent pas les approbations — ils ajoutent un tableau, une liste et un Gantt partagés, ainsi que des liens inter-projets.",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "Les portefeuilles n’affectent ni les permissions ni les approbations — ils servent uniquement à organiser et à rapporter.",
  "Portfolios →": "Portefeuilles →",
  "Post the comment": "Publier le commentaire",
  "Post the comment (Ctrl-Enter)": "Publier le commentaire (Ctrl-Entrée)",
  "Prev": "Préc.",
  "Preview": "Aperçu",
  "Previous month": "Mois précédent",
  "Previous week": "Semaine précédente",
  "Priority": "Priorité",
  "Priority…": "Priorité…",
  "Private projects filed here that only their owners can see": "Projets privés rattachés ici que seuls leurs propriétaires peuvent voir",
  "Private — only you can see this project": "Privé — vous seul pouvez voir ce projet",
  "Private — only you will see this project": "Privé — vous seul verrez ce projet",
  "Progress": "Progression",
  "Project": "Projet",
  "Project colour": "Couleur du projet",
  "Project not found, or you do not have access.": "Projet introuvable, ou vous n’y avez pas accès.",
  "Project not found.": "Projet introuvable.",
  "Project role": "Rôle dans le projet",
  "Project the new task belongs to": "Projet auquel appartient la nouvelle tâche",
  "Projected finish": "Fin projetée",
  "Projects": "Projets",
  "Projects not yet in a portfolio that you may update": "Projets que vous pouvez modifier et qui ne sont pas encore dans un portefeuille",
  "Projects you are a member of.": "Projets dont vous êtes membre.",
  "Projects you can see. Managers and admins see all.": "Projets que vous pouvez voir. Les managers et admins voient tout.",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "Purger immédiatement avec la politique actuellement enregistrée (pas les modifications non enregistrées) et consigner les comptes ci-dessus",
  "Push successors when a task moves": "Décaler les successeurs quand une tâche est déplacée",
  "Range": "Période",
  "Rates are visible to managers and administrators.": "Les tarifs sont visibles par les managers et administrateurs.",
  "Read this first.": "Lisez ceci d’abord.",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "Les jetons en lecture ne font que consulter ; les jetons en écriture peuvent aussi créer et modifier des tâches, liens, jalons et saisies de temps. Tout ce qu’un jeton fait est audité en votre nom, avec le nom du jeton.",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "Lecture seule : les réunions du jour apparaissent comme suggestions en un clic sur la page Temps. Vos saisies reviennent vers n’importe quel calendrier via le",
  "Read: look only. Write: create and change tasks, links, milestones and time": "Lecture : consulter seulement. Écriture : créer et modifier tâches, liens, jalons et temps",
  "Ready": "Prêt",
  "Recently completed": "Récemment terminées",
  "Regenerate": "Régénérer",
  "Regenerate link": "Régénérer le lien",
  "Regenerate recovery codes": "Régénérer les codes de récupération",
  "Regenerate the secret link (old link stops working)": "Régénérer le lien secret (l’ancien lien cesse de fonctionner)",
  "Remove": "Retirer",
  "Remove item": "Retirer l’élément",
  "Remove this calendar": "Retirer ce calendrier",
  "Remove this checklist item": "Retirer cet élément de checklist",
  "Remove this comment; its replies stay": "Retirer ce commentaire ; ses réponses sont conservées",
  "Repeats": "Se répète",
  "Reply": "Répondre",
  "Reply in this thread": "Répondre dans ce fil",
  "Report name": "Nom du rapport",
  "Reports": "Rapports",
  "Request": "Demander",
  "Request failed": "La requête a échoué",
  "Request leave": "Demander un congé",
  "Reset your password": "Réinitialiser votre mot de passe",
  "Result": "Résultat",
  "Resume": "Reprendre",
  "Resume (pauses the running timer)": "Reprendre (met en pause le chrono en cours)",
  "Resume this timer (pauses the running one)": "Reprendre ce chrono (met en pause celui en cours)",
  "Retake baseline": "Reprendre la référence",
  "Retention": "Rétention",
  "Return the week with a note; the person edits and resubmits": "Renvoyer la semaine avec une note ; la personne la modifie et la resoumet",
  "Revoke": "Révoquer",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "Révoquer le jeton « {name} » ? Tout ce qui l’utilise cesse de fonctionner immédiatement.",
  "Revoked:": "Révoqués :",
  "Role": "Rôle",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "Exécuter ce rapport automatiquement à la cadence choisie et le livrer par e-mail/notification",
  "Save": "Enregistrer",
  "Save every change on this record": "Enregistrer toutes les modifications de cette fiche",
  "Save policy": "Enregistrer la politique",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "Enregistrer la politique stocke les valeurs pour l’exécution nocturne. Exécuter maintenant purge immédiatement avec la politique enregistrée.",
  "Save the current grouping and filters under a name": "Enregistrer le regroupement et les filtres actuels sous un nom",
  "Save these recovery codes now.": "Enregistrez ces codes de récupération maintenant.",
  "Saved reports…": "Rapports enregistrés…",
  "Saved ✓": "Enregistré ✓",
  "Saved.": "Enregistré.",
  "Schedule": "Planifier",
  "Schedule end": "Fin planifiée",
  "Schedule settings per project": "Paramètres de planification par projet",
  "Scheduled reports": "Rapports planifiés",
  "Scope": "Portée",
  "Scroll the timeline back to today": "Ramener la chronologie à aujourd’hui",
  "Search": "Rechercher",
  "Search code or name…": "Rechercher code ou nom…",
  "Search…": "Rechercher…",
  "Send the request to your line manager (some types are approved automatically)": "Envoyer la demande à votre manager (certains types sont approuvés automatiquement)",
  "Send them a password reset link from the directory when they are ready to sign in.": "Envoyez-lui un lien de réinitialisation depuis l’annuaire quand elle pourra se connecter.",
  "Send them this link — it is shown once and expires in 7 days:": "Envoyez-leur ce lien — il n’est affiché qu’une fois et expire dans 7 jours :",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "Envoyer cette semaine-projet à l’administrateur du projet pour approbation ; vous pouvez la retirer jusqu’à sa décision",
  "Sent back": "Renvoyé",
  "Service account": "Compte de service",
  "Set a new password for": "Définir un nouveau mot de passe pour",
  "Set a password": "Définir un mot de passe",
  "Set status…": "Définir le statut…",
  "Set the task and a note when you start, or edit them in the list.": "Définissez la tâche et une note au démarrage, ou modifiez-les dans la liste.",
  "Set up your account": "Configurez votre compte",
  "Settings": "Paramètres",
  "Share with project": "Partager avec le projet",
  "Show": "Afficher",
  "Show archived": "Afficher les archivés",
  "Show failed sign-in attempts": "Afficher les tentatives de connexion échouées",
  "Show service accounts": "Afficher les comptes de service",
  "Show sign-in attempts": "Afficher les tentatives de connexion",
  "Show subtasks": "Afficher les sous-tâches",
  "Show the audit log": "Afficher le journal d’audit",
  "Show the comment formatted, as it will appear": "Afficher le commentaire mis en forme, tel qu’il apparaîtra",
  "Show this project in your lists again": "Réafficher ce projet dans vos listes",
  "Show this project's tasks": "Afficher les tâches de ce projet",
  "Show what this comment said before it was edited": "Voir ce que disait ce commentaire avant sa modification",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "Affiche sa journée aux bonnes heures ; ne change jamais la semaine à laquelle une saisie appartient.",
  "Sign in": "Se connecter",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "Connectez-vous avec l’empreinte, le visage ou le code PIN de votre appareil, ou une clé matérielle — sans mot de passe ni code. Les clés d’accès résistent au hameçonnage.",
  "Sign out": "Se déconnecter",
  "Signed in": "Connecté",
  "Signing in…": "Connexion…",
  "Since": "Depuis",
  "Sortable table of tasks across every project in the portfolio": "Tableau triable des tâches de tous les projets du portefeuille",
  "Sortable table of tasks with bulk edit and saved views": "Table triable des tâches avec édition en masse et vues enregistrées",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "Démarrer (ou basculer) votre chrono de ce projet sur cette tâche ; tout chrono en cours se met en pause",
  "Start a timer for this project (pauses any running timer)": "Démarrer un chrono pour ce projet (met en pause tout chrono en cours)",
  "Start timer": "Démarrer le chrono",
  "Start timer on this task": "Démarrer le chrono sur cette tâche",
  "Starts": "Début",
  "State": "État",
  "Status": "Statut",
  "Stop and save": "Arrêter et enregistrer",
  "Stop and save one time entry for the total": "Arrêter et enregistrer une saisie de temps pour le total",
  "Stop and save one time entry for the total on this project": "Arrêter et enregistrer une saisie de temps pour le total sur ce projet",
  "Stop anything using this token, immediately": "Arrêter immédiatement tout ce qui utilise ce jeton",
  "Stop at idle — save up to the idle moment and stop": "Arrêter à l’inactivité — enregistrer jusqu’à ce moment et arrêter",
  "Stop reading your Google Calendar": "Arrêter la lecture de votre Google Agenda",
  "Stop the timer running on this task and save one time entry": "Arrêter le chrono en cours sur cette tâche et enregistrer une saisie de temps",
  "Stop timer": "Arrêter le chrono",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "Stocker ces valeurs comme politique ; la purge nocturne les utilise dès sa prochaine exécution",
  "Subscribe": "S’abonner",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "Abonnez votre application de calendrier à ce lien pour voir vos tâches (échéances), congés, les jalons de vos projets et vos 90 derniers jours de saisies de temps.",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "Abonnez votre application de calendrier à vos tâches, congés, jalons et saisies de temps récentes.",
  "Swimlanes": "Couloirs",
  "System state, the audit trail, and sign-in activity. People and invites are under": "État du système, piste d’audit et activité de connexion. Les personnes et invitations sont sous",
  "Take baseline": "Prendre la référence",
  "Take the project out of this portfolio (the project itself is unchanged)": "Retirer le projet de ce portefeuille (le projet lui-même reste inchangé)",
  "Take the submission back to edit the week; resubmit when ready": "Reprendre la soumission pour modifier la semaine ; resoumettez quand c’est prêt",
  "Task": "Tâche",
  "Task (optional)": "Tâche (facultatif)",
  "Task this timer is for (optional)": "Tâche concernée par ce chrono (facultatif)",
  "Task title": "Titre de la tâche",
  "Tasks": "Tâches",
  "Tasks can't move between projects": "Les tâches ne peuvent pas passer d’un projet à l’autre",
  "Tasks live inside projects; open Projects": "Les tâches vivent dans les projets ; ouvrez Projets",
  "Team (last 30 days)": "Équipe (30 derniers jours)",
  "That does not look like a valid zone.": "Cela ne ressemble pas à un fuseau valide.",
  "The calendar's public iCal URL": "L’URL iCal publique du calendrier",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "Le lien est un secret — quiconque le détient peut lire votre flux. Régénérez-le en cas de fuite.",
  "The numbers below are the": "Les valeurs ci-dessous sont la",
  "The person accountable for the portfolio; always a portfolio administrator": "La personne responsable du portefeuille ; toujours administrateur du portefeuille",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "Le jeton n’est affiché qu’une fois, à sa création. Révoquez-le ici en cas de fuite.",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "Lancez ensuite Claude Code et demandez-lui, par exemple, « qu’est-ce qui est en retard dans mon portefeuille ? » ou « planifie l’épopée importateur dans DEN avec quatre tâches et relie-les ».",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "Il n’y a pas encore de mot de passe : personne ne peut se connecter en son nom. Émettez un lien de réinitialisation depuis l’annuaire quand elle sera prête.",
  "They can sign in with the password you set.": "Elle peut se connecter avec le mot de passe que vous avez défini.",
  "This account can only be used from these addresses (set by an administrator):": "Ce compte ne peut être utilisé que depuis ces adresses (défini par un administrateur) :",
  "This browser does not support passkeys.": "Ce navigateur ne prend pas en charge les clés d’accès.",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "Cette invitation est invalide ou a expiré. Demandez-en une nouvelle à un administrateur.",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "Ce mot de passe s’affiche une seule fois et ne sera plus jamais montré. Transmettez-le par un canal de confiance ; la personne pourra le changer dans Compte.",
  "Throw this timer away without saving": "Jeter ce chrono sans enregistrer",
  "Time": "Temps",
  "Time is approved per project, per week, in each project's own timezone.": "Le temps est approuvé par projet, par semaine, dans le fuseau horaire de chaque projet.",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "Les congés sont approuvés par votre manager et réduisent votre capacité disponible cette semaine-là — ils ne comptent jamais comme heures travaillées.",
  "Timeline across projects: cross-project links, critical path": "Chronologie inter-projets : liens inter-projets, chemin critique",
  "Timeline: drag bars, link dependencies, critical path, baseline": "Chronologie : faites glisser les barres, liez les dépendances, chemin critique, référence",
  "Timesheets": "Feuilles de temps",
  "Timezone": "Fuseau horaire",
  "Timezone of truth": "Fuseau horaire de référence",
  "Title": "Titre",
  "Title of the new task; you can fill in the rest from the task editor": "Titre de la nouvelle tâche ; vous pourrez compléter le reste dans l’éditeur de tâche",
  "To": "À",
  "To confirm, type your name exactly:": "Pour confirmer, saisissez votre nom exactement :",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "Pour connecter Claude Code avec ce compte, placez le jeton dans le shell et ajoutez le serveur une fois :",
  "To do": "À faire",
  "To use it from Claude Code, put it in your shell and add the server once:": "Pour l’utiliser depuis Claude Code, placez-le dans votre shell et ajoutez le serveur une fois :",
  "Token": "Jeton",
  "Token name, e.g. Claude Code": "Nom du jeton, par ex. Claude Code",
  "Token name, e.g. Claude Code on my laptop": "Nom du jeton, p. ex. Claude Code sur mon portable",
  "Top": "Haut",
  "Turn off": "Désactiver",
  "Turn off authenticator": "Désactiver l’authentificateur",
  "Turn on": "Activer",
  "Type @ to mention someone · Ctrl-Enter posts": "Tapez @ pour mentionner quelqu’un · Ctrl-Entrée publie",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "Saisissez une commande, un projet, une clé de tâche ou un nom…  (Ctrl-K bascule)",
  "Type your display name exactly to enable the final button": "Saisissez exactement votre nom d’affichage pour activer le bouton final",
  "Unarchive": "Désarchiver",
  "Unassigned": "Non assigné",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "Déverrouiller une semaine approuvée pour modification ; nécessite un motif, consigné dans le journal d’audit, et notifie la personne",
  "Unshare": "Ne plus partager",
  "Upcoming milestones": "Jalons à venir",
  "Update password": "Mettre à jour le mot de passe",
  "Upload": "Téléverser",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "Utilisez-les pour tester un changement avec quelques personnes d’abord, ou pour désactiver rapidement une fonctionnalité qui se comporte mal.",
  "Velocity": "Vélocité",
  "Velocity (estimate hours done per week)": "Vélocité (heures estimées terminées par semaine)",
  "Velocity per week": "Vélocité par semaine",
  "Verify": "Vérifier",
  "Views…": "Vues…",
  "WIP limit": "Limite WIP",
  "Week": "Semaine",
  "Week of": "Semaine du",
  "Weeks awaiting submission": "Semaines en attente de soumission",
  "Weeks from": "Semaines à partir de",
  "Weeks run Monday→Monday in": "Les semaines vont du lundi au lundi en",
  "What": "Quoi",
  "What did you work on?": "Sur quoi avez-vous travaillé ?",
  "What they see the app in until they choose otherwise.": "La langue dans laquelle la personne voit l’application jusqu’à ce qu’elle en choisisse une autre.",
  "What this person costs per hour (effective-dated); click to view history or change it": "Ce que cette personne coûte par heure (daté d’effet) ; cliquez pour voir l’historique ou le modifier",
  "When": "Quand",
  "When done, the next occurrence is created with dates shifted.": "Une fois terminé, l’occurrence suivante est créée avec les dates décalées.",
  "When the token stops working on its own": "Quand le jeton cesse de fonctionner de lui-même",
  "Where password resets go. Change it and they are emailed about it.": "L’adresse où arrivent les réinitialisations de mot de passe. Si vous la changez, la personne en est informée par e-mail.",
  "Which project the new timer is for": "Projet auquel appartient le nouveau chrono",
  "Who": "Qui",
  "Working days per week": "Jours travaillés par semaine",
  "Write": "Écrire",
  "Write a comment…": "Écrire un commentaire…",
  "Write a reply…": "Écrire une réponse…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "Vous n’êtes encore membre d’aucun projet, il n’y a donc nulle part où saisir du temps. Demandez à un administrateur de projet de vous ajouter.",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "Vous en devenez le manager ; ajoutez des projets et des membres depuis la page du portefeuille, ou rattachez un projet depuis ses",
  "You can also send them the link directly:": "Vous pouvez aussi leur envoyer le lien directement :",
  "You can see this project's tasks here but not change them": "Vous pouvez voir ici les tâches de ce projet, mais pas les modifier",
  "You do not have access to this page.": "Vous n’avez pas accès à cette page.",
  "You have been invited as": "Vous avez été invité en tant que",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "Vous n’avez pas de manager défini, les demandes attendront donc un administrateur. Demandez à un admin de définir votre manager sous Personnes.",
  "You need edit rights in both projects to link them": "Vous devez avoir les droits de modification dans les deux projets pour les lier",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "Vous vous connectez avec Google, qui gère l’authentification à deux facteurs pour vous. Ces options s’appliquent à la connexion par mot de passe.",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "Vous vous connectez avec Google. Un mot de passe vous offre une solution de repli si Google est indisponible.",
  "Your colleagues.": "Vos collègues.",
  "Your feed (out)": "Votre flux (sortant)",
  "Your name": "Votre nom",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "Votre propre fuseau, pour l’affichage. Les projets gardent leur fuseau horaire de référence.",
  "Your role": "Votre rôle",
  "Your role requires a second factor for password sign-in. Set up an": "Votre rôle exige un second facteur pour la connexion par mot de passe. Configurez une",
  "Your week is shown in": "Votre semaine est affichée en",
  "active people": "personnes actives",
  "active projects": "projets actifs",
  "approvals arrive in Phase 3": "les approbations arrivent en Phase 3",
  "archived": "archivé",
  "assignee: clear": "responsable : effacer",
  "assignee: keep": "responsable : conserver",
  "audit trail for this project": "piste d’audit de ce projet",
  "billable hours": "heures facturables",
  "billed amount": "montant facturé",
  "by": "par",
  "change in Settings": "modifier dans Paramètres",
  "closes Monday": "clôture lundi",
  "comments and @mentions about the project as a whole": "commentaires et @mentions sur l’ensemble du projet",
  "cost": "coût",
  "cost / hour": "coût / heure",
  "created": "créé",
  "created → done": "créé → terminé",
  "created. Copy it now — it will not be shown again.": "créé. Copiez-le maintenant — il ne sera plus affiché.",
  "critical tasks": "tâches critiques",
  "current": "actuel",
  "current + new + confirm": "actuel + nouveau + confirmation",
  "current 6-digit code": "code à 6 chiffres actuel",
  "days": "jours",
  "deleted": "supprimé",
  "description, dashboard": "description, tableau de bord",
  "devices signed in as you": "appareils connectés en votre nom",
  "done": "terminé",
  "download everything stored about you": "téléchargez tout ce qui est stocké à votre sujet",
  "due +days": "échéance +jours",
  "edited": "modifié",
  "edited by": "modifié par",
  "estimate hours": "heures estimées",
  "every 2 weeks": "toutes les 2 semaines",
  "every day": "chaque jour",
  "every month": "chaque mois",
  "every quarter": "chaque trimestre",
  "every week": "chaque semaine",
  "extra recipients (comma-separated)": "destinataires supplémentaires (séparés par des virgules)",
  "failed sign-ins (24h)": "connexions échouées (24 h)",
  "feed URL, Google Calendar, external calendars": "URL du flux, Google Agenda, calendriers externes",
  "fingerprint, face, security key": "empreinte, visage, clé de sécurité",
  "for Claude Code and scripts": "pour Claude Code et les scripts",
  "from": "de",
  "generate one and show it to me once": "en générer un et me l’afficher une fois",
  "hidden": "masqué",
  "hours": "heures",
  "hours and money caps, alerts": "plafonds d’heures et d’argent, alertes",
  "hours logged": "heures saisies",
  "hours logged (yours where restricted)": "heures saisies (les vôtres là où c’est restreint)",
  "iCal subscription link": "lien d’abonnement iCal",
  "in": "dans",
  "in progress": "en cours",
  "kept": "conservé",
  "last 30 days": "30 derniers jours",
  "last month": "mois dernier",
  "last week": "semaine dernière",
  "latest scheduled finish across projects": "fin planifiée la plus tardive parmi les projets",
  "list view, editor, checklists": "vue liste, éditeur, checklists",
  "live sessions": "sessions actives",
  "logged this week": "saisi cette semaine",
  "median cycle time (days)": "temps de cycle médian (jours)",
  "median lead time (days)": "délai médian (jours)",
  "month to date": "mois en cours",
  "name, dates, timezone, archive": "nom, dates, fuseau, archivage",
  "name, description, portfolio manager, archive": "nom, description, manager du portefeuille, archivage",
  "name, language, timezone": "nom, langue, fuseau horaire",
  "navigate · Enter run · Esc close": "naviguer · Entrée exécuter · Échap fermer",
  "never": "jamais",
  "never expires": "n’expire jamais",
  "no estimates yet": "pas encore d’estimations",
  "no rate — billable time counts as unrated": "aucun tarif — le temps facturable compte comme non tarifé",
  "no scheduled tasks yet": "pas encore de tâches planifiées",
  "non-billable": "non facturable",
  "none yet": "aucune pour l’instant",
  "none — portfolio views assign a palette colour": "aucune — les vues de portefeuille attribuent une couleur de la palette",
  "none — they cannot sign in yet": "aucun — la personne ne peut pas encore se connecter",
  "now has an account.": "a désormais un compte.",
  "off": "désactivée",
  "office, home…": "bureau, domicile…",
  "on": "activée",
  "open tasks assigned to me": "tâches ouvertes qui me sont assignées",
  "or set a password": "ou définissez un mot de passe",
  "or use a password": "ou utilisez un mot de passe",
  "overdue": "en retard",
  "overdue ·": "en retard ·",
  "payroll-ready": "prêt pour la paie",
  "people are": "personnes sont",
  "permanent — read first": "personne est",
  "person is": "permanent — lisez d’abord",
  "person's zone": "fuseau de la personne",
  "policy": "politique",
  "portfolio": "portefeuille",
  "portfolio administrator": "administrateur du portefeuille",
  "portfolio end": "fin du portefeuille",
  "predecessor": "prédécesseur",
  "priority: keep": "priorité : conserver",
  "private": "privé",
  "project administrator": "administrateur du projet",
  "project zone": "fuseau du projet",
  "projected finish": "fin projetée",
  "projects": "projets",
  "rate / hour": "tarif / heure",
  "read and write": "lecture et écriture",
  "read only": "lecture seule",
  "read this once": "à lire une fois",
  "read-only": "lecture seule",
  "rejected — resubmit": "refusé — resoumettre",
  "service account": "compte de service",
  "set one now": "en définir un maintenant",
  "subtask": "sous-tâche",
  "synced": "synchronisé",
  "system": "système",
  "taken": "prise le",
  "task count": "nombre de tâches",
  "tasks": "tâches",
  "tasks done": "tâches terminées",
  "then": "puis",
  "this device": "cet appareil",
  "this week": "cette semaine",
  "throughput": "débit",
  "time entries": "saisies de temps",
  "time-based codes (TOTP)": "codes temporels (TOTP)",
  "to": "à",
  "to do": "à faire",
  "two-way sync": "synchronisation bidirectionnelle",
  "unassigned": "non assigné",
  "updated": "mis à jour",
  "velocity (h / week)": "vélocité (h / semaine)",
  "via API token": "via jeton d’API",
  "week start": "début de semaine",
  "weeks awaiting submission": "semaines en attente de soumission",
  "workflow columns and transitions": "colonnes de flux et transitions",
  "your hours logged": "vos heures saisies",
  "your password": "votre mot de passe",
  "zero slack: a delay moves the end date": "marge nulle : un retard décale la date de fin",
  "{n} people notified": "{n} personnes notifiées",
  "{n} private projects are hidden from these totals.": "{n} projets privés sont masqués dans ces totaux.",
  "{n} private projects hidden": "{n} projets privés masqués",
  "{n} projects": "{n} projets",
  "— (top level)": "— (premier niveau)",
  "— no task —": "— aucune tâche —",
  "— none —": "— aucun —",
  "— unassigned —": "— non assigné —",
  "🔒 approved": "🔒 approuvé",
  "Task completed.": "Tâche terminée.",
  "Task reopened.": "Tâche rouverte.",
  "Action": "Action",
  "Actions": "Actions",
  "Budget": "Budget",
  "Burndown / burnup": "Burndown / burnup",
  "Code": "Code",
  "Date": "Date",
  "Dates": "Dates",
  "Description": "Description",
  "Est.": "Est.",
  "Format": "Format",
  "Gantt": "Gantt",
  "Manager": "Manager",
  "Note": "Note",
  "Notes": "Notes",
  "Notifications": "Notifications",
  "Parent": "Parent",
  "Pause": "Pause",
  "Total": "Total",
  "Type": "Type",
  "Zoom": "Zoom",
  "correction": "correction",
  "est. h": "est. h",
  "migrations": "migrations",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "S’applique immédiatement à ce navigateur et à tous les appareils où vous vous connectez ; remplace la langue du navigateur.",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "Un lien de confirmation a été envoyé à la nouvelle adresse (valable 2 jours). Votre e-mail change quand vous l’ouvrez.",
  "Cancel it": "L’annuler",
  "Change email": "Changer l’e-mail",
  "Change now": "Changer maintenant",
  "Change now (with password)": "Changer maintenant (avec mot de passe)",
  "Change the email immediately": "Changer l’e-mail immédiatement",
  "Changed. Use the new address next time you sign in.": "Modifié. Utilisez la nouvelle adresse à votre prochaine connexion.",
  "Confirm email": "Confirmer l’e-mail",
  "Done — your sign-in email is now": "Terminé — votre e-mail de connexion est désormais",
  "Either way the old address is told, and the change is recorded in the audit log.": "Dans les deux cas, l’ancienne adresse est prévenue et le changement est consigné dans le journal d’audit.",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "La messagerie n’est pas configurée sur ce serveur ; ouvrez donc ce lien vous-même (valable 2 jours) :",
  "New email": "Nouvel e-mail",
  "Send a confirmation link to the new address": "Envoyer un lien de confirmation à la nouvelle adresse",
  "Send confirmation link": "Envoyer le lien de confirmation",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "Ce compte se connecte avec Google : son e-mail est géré par Google et ne peut pas être modifié ici.",
  "Verify first": "Vérifier d’abord",
  "Verify first (send a link)": "Vérifier d’abord (envoyer un lien)",
  "Waiting for confirmation of": "En attente de confirmation de",
  "Your email is what you sign in with and where notifications are mailed.": "Votre e-mail sert à vous connecter et à recevoir les notifications.",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "un lien est envoyé à la nouvelle adresse ; le changement a lieu quand vous l’ouvrez, une faute de frappe ne peut donc pas vous bloquer.",
  "enter your current password and the address changes immediately.": "saisissez votre mot de passe actuel et l’adresse change immédiatement.",
  "expires": "expire",
  "A status update is waiting to be sent to GitHub": "Une mise à jour de statut attend d’être envoyée à GitHub",
  "API calls left this hour": "appels API restants cette heure",
  "Assign to matching people": "Attribuer aux personnes correspondantes",
  "Close and reopen issues when task status changes": "Fermer et rouvrir les issues quand le statut de la tâche change",
  "Connect": "Connecter",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "Connectez un dépôt pour importer ses issues en tâches. Quand une tâche est terminée ici, l’issue est fermée sur GitHub ; quand une issue est fermée ou rouverte sur GitHub, la tâche suit.",
  "Connected to": "Connecté à",
  "Could not load the GitHub connection.": "Impossible de charger la connexion GitHub.",
  "Create missing milestones": "Créer les jalons manquants",
  "Disconnect": "Déconnecter",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "Déconnecter ce dépôt ? Les liens d’issues existants sont conservés ; rien n’est supprimé sur GitHub.",
  "Fine-grained personal access token": "Jeton d’accès personnel à granularité fine",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "GITHUB_WEBHOOK_SECRET n’est pas défini sur le serveur : les changements faits sur GitHub arrivent dans APM par sondage horaire ou via « Synchroniser », pas instantanément.",
  "GitHub": "GitHub",
  "GitHub username": "Nom d’utilisateur GitHub",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens. Limitez-le à ce dépôt avec la permission Issues : Read and write (Metadata est inclus automatiquement). Le jeton est vérifié maintenant, stocké chiffré et jamais réaffiché.",
  "Import issues": "Importer des issues",
  "Import issues…": "Importer des issues…",
  "Importing…": "Importation…",
  "Issue closed as completed →": "Issue fermée comme terminée →",
  "Issue closed as not planned →": "Issue fermée comme non planifiée →",
  "Issue reopened →": "Issue rouverte →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "Les issues attribuées à cet utilisateur GitHub deviennent des tâches qui vous sont attribuées quand un projet les importe.",
  "Labels": "Étiquettes",
  "Mirror the task status as an apm:… label": "Refléter le statut de la tâche sous forme d’étiquette apm:…",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "Passer une tâche dans ce statut ferme l’issue comme « non planifiée » ; tout autre statut terminé la ferme comme « terminée ».",
  "No APM account has this GitHub username": "Aucun compte APM n’a ce nom d’utilisateur GitHub",
  "No issues match.": "Aucune issue ne correspond.",
  "Priority from labels": "Priorité selon les étiquettes",
  "Replace the token or test the connection to resume.": "Remplacez le jeton ou testez la connexion pour reprendre.",
  "Replace token": "Remplacer le jeton",
  "Repository": "Dépôt",
  "Status mapping": "Correspondance des statuts",
  "Sync history": "Historique de synchronisation",
  "Sync is paused:": "La synchronisation est en pause :",
  "Sync now": "Synchroniser",
  "Synced:": "Synchronisé :",
  "Syncing…": "Synchronisation…",
  "Test connection": "Tester la connexion",
  "Webhook: add": "Webhook : ajoutez",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "Quand une issue importée porte l’une de ces étiquettes, la tâche reçoit la priorité correspondante (la première correspondance l’emporte).",
  "all": "toutes",
  "already linked": "déjà liées",
  "attempt": "tentative",
  "checked": "vérifiées",
  "closed": "fermée",
  "create": "créer",
  "errors": "erreurs",
  "failed": "échecs",
  "first done status": "premier statut terminé",
  "first to-do status": "premier statut à faire",
  "import issues as tasks, sync status": "importer des issues en tâches, synchroniser le statut",
  "label, e.g. bug": "étiquette, ex. bug",
  "labels, comma-separated": "étiquettes, séparées par des virgules",
  "last checked": "dernière vérification",
  "linked issues": "issues liées",
  "next": "suivante",
  "not planned": "non planifiée",
  "nothing to do": "rien à faire",
  "open": "ouverte",
  "open issues": "issues ouvertes",
  "page": "page",
  "previous": "précédente",
  "remove": "retirer",
  "running": "en cours",
  "same as completed": "identique à terminée",
  "search title or #number": "rechercher un titre ou #numéro",
  "sent to GitHub": "envoyées à GitHub",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "au dépôt avec le GITHUB_WEBHOOK_SECRET du serveur, type de contenu JSON, événements : Issues, Pushes, Pull requests. Sans cela, les changements arrivent quand même par sondage horaire ou via « Synchroniser ».",
  "token": "jeton",
  "update": "mettre à jour",
  "update pending": "mise à jour en attente",
  "updated here": "mises à jour ici",
  "updates waiting": "mises à jour en attente",
  "Open menu": "Ouvrir le menu",
  "Close menu": "Fermer le menu",
  "Main menu": "Menu principal",
  "Management": "Gestion",
}
